import { i18nNsFactory } from '@atlas-frontend/i18n';
import { path } from '../../paths';
import { UiLink } from '../../paths/UiLink';
import { useNavigateTo } from '../../paths/useNavigateTo';
import translations from './translations/InputDataObjectDirectory.translations.json';
import { DataObjectView } from '@atlas-frontend/sdk';
import { DataObjectDirectory } from '../data-objects/DataObjectDirectory';
import { Helmet } from 'react-helmet-async';

const { addTranslations, useTranslation } = i18nNsFactory(
  'input-data-object-table'
);
addTranslations(translations);

export const InputDataObjectDirectory = () => {
  const { t } = useTranslation();
  const navigateToInputDataObjectCreate = useNavigateTo(
    path.inputDataObjectCreate
  );
  const navigateToInputDataObjectView = useNavigateTo(path.inputDataObjectView);

  return (
    <>
      <Helmet>
        <title>{t('title.header')}</title>
      </Helmet>
      <DataObjectDirectory
        title={t('title.header')}
        view={DataObjectView.IN}
        getRedirectAnchor={getRedirectAnchor}
        onClickCreate={navigateToInputDataObjectCreate}
        onSelectVersion={(params: { id?: number }) =>
          params?.id
            ? navigateToInputDataObjectView({ id: String(params.id) })
            : undefined
        }
      />
    </>
  );
};

const getRedirectAnchor = (versionId: number, value: string) => (
  <UiLink
    id={`dataObject-version-${versionId}`}
    path={path.inputDataObjectView}
    params={{ id: versionId }}
  >
    {value}
  </UiLink>
);
